var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpportunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#949494"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2497 21.084H24.4163C23.6649 21.084 22.9442 21.3825 22.4129 21.9138C21.8815 22.4452 21.583 23.1659 21.583 23.9173V40.9173C21.583 41.6688 21.8815 42.3894 22.4129 42.9208C22.9442 43.4521 23.6649 43.7507 24.4163 43.7507H38.583C39.3345 43.7507 40.0551 43.4521 40.5865 42.9208C41.1178 42.3894 41.4163 41.6688 41.4163 40.9173V23.9173C41.4163 23.1659 41.1178 22.4452 40.5865 21.9138C40.0551 21.3825 39.3345 21.084 38.583 21.084H35.7497",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 29.5833H30.7917C30.2281 29.5833 29.6876 29.8072 29.2891 30.2057C28.8905 30.6042 28.6667 31.1447 28.6667 31.7083C28.6667 32.2719 28.8905 32.8124 29.2891 33.2109C29.6876 33.6094 30.2281 33.8333 30.7917 33.8333H32.2083C32.7719 33.8333 33.3124 34.0572 33.7109 34.4557C34.1095 34.8542 34.3333 35.3947 34.3333 35.9583C34.3333 36.5219 34.1095 37.0624 33.7109 37.4609C33.3124 37.8594 32.7719 38.0833 32.2083 38.0833H28.6667M31.5 38.0833V39.5M31.5 28.1667V29.5833M27.25 21.0833C27.25 20.3319 27.5485 19.6112 28.0799 19.0799C28.6112 18.5485 29.3319 18.25 30.0833 18.25H32.9167C33.6681 18.25 34.3888 18.5485 34.9201 19.0799C35.4515 19.6112 35.75 20.3319 35.75 21.0833C35.75 21.8348 35.4515 22.5554 34.9201 23.0868C34.3888 23.6182 33.6681 23.9167 32.9167 23.9167H30.0833C29.3319 23.9167 28.6112 23.6182 28.0799 23.0868C27.5485 22.5554 27.25 21.8348 27.25 21.0833Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunity);
export default __webpack_public_path__ + "static/media/opportunity.5bd2fa331e6be1a773fe0d5d0ef1acaf.svg";
export { ForwardRef as ReactComponent };